import React from "react";
import InvalidFeedback from "./InvalidFeedback";
import FormGroup from "./FormGroup";

const FormGroupInput = (
    {
        id,
        type = 'text',
        label,
        placeholder,
        name,
        value= '',
        onChange,
        error,
        noLabel = false,
        prepend,
        append,
    }) => {

    return (
        <FormGroup
            label={label}
            noLabel={noLabel}
            prepend={prepend}
            append={append}
            name={name}
            error={error}
            htmlFor={!!id ? id : name}
        >
            <input
                id={id}
                type={type}
                className={`form-control ${!!error && 'is-invalid'}`}
                placeholder={placeholder}
                name={name}
                onChange={onChange}
                value={value}
            />
        </FormGroup>
    )
}

export default FormGroupInput;
